import { createElement } from 'react';
import styles from './VisuallyHidden.module.css';
/**
 * Renders content that is visually hidden but exposed to assistive
 * technology. Use sparingly — visible labels are almost always better.
 *
 * Every HTML attribute passes through to the rendered element, so this
 * doubles as an off-screen live region: `<VisuallyHidden role="status"
 * aria-live="polite">…</VisuallyHidden>`. `id` still threads through for
 * `aria-labelledby` targets.
 */
export const VisuallyHidden = ({ as = 'span', children, className, ...rest }) => createElement(as, {
    className: [styles.root, className].filter(Boolean).join(' '),
    ...rest,
}, children);
//# sourceMappingURL=VisuallyHidden.js.map